import { isLoginedNative, openNativePage } from '@/utils/bridge';
import { checkLogin } from '@/utils/utils';
/**
 * 登录页
 * @param {number} type 登录态失效类型(0 登录态失效-默认, 1 账号被踢)
 */
export function routeToLogin(type = 0, callback = () => {}) {
  const closeH5 = false;
  openNativePage(
    {
      path: '/login',
      params: {
        type,
      },
    },
    closeH5,
    callback
  );
}

// 首页
export function routeToHome() {
  openNativePage({
    path: '/home',
    tab: 1,
  });
}

/**
 * 订单列表页
 * @param {number} tab (0 全部-默认, 1 待付款, 2 已完成, 3 已取消)
 */
export function routeToOrderList(tab = 0) {
  openNativePage({
    path: '/order/list',
    tab,
  });
}

//导出报表页面
export function routeToExportReport(gid = -1) {
  const closeH5 = false;
  openNativePage(
    {
      path: '/export/report',
      gid,
    },
    closeH5
  );
}

//设备详情页
export function routeToDeviceDetail(data) {
  const closeH5 = false;
  openNativePage(
    {
      path: '/h5/device/details',
      params: data,
    },
    closeH5
  );
}

// 跳转到登录页并更新登录态
export const routeToLoginAndUpdateStatus = (type = 0) => {
  routeToLogin(type, checkLogin);
};

// 检查登录态，如果没有登录跳转到登录页，若登录了则执行回调
export const checkAndRouteToLoginAndUpdateStatus = async callback => {
  const appRes = await isLoginedNative();
  if (appRes?.code === 0) {
    const newStatus = appRes.data.status;
    if (newStatus) {
      callback && callback();
    } else {
      routeToLogin(0, () => {
        checkLogin(callback);
      });
    }
    // 更新全局登录态
    window.g_app._store.dispatch({
      type: 'user/updateLoginState',
      payload: newStatus,
    });
  }
};
